export default "__VITE_ASSET__gU6nkG$B__"